import { JsonObject } from '../helpers';

const ProviderModelNameMap: Record<string, string> = {
  google: 'Gemini',
  'google-ai-studio': 'Gemini',
  openai: 'OpenAI',
  'azure-openai': 'OpenAI',
  perplexity: 'Perplexity',
};

export class ProviderModel {
  orgId: string; // Required, matches pattern ^[a-f\d]{24}$
  name: string; // Required, max length 255
  provider: string; // Required, max length 255
  modelId: string; // Required
  modelProviderName: string;
  inputModalities: string[];
  outputModalities: string[];
  connectorId: string;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof ProviderModel, unknown>;

    this.orgId = (data.orgId as string) || '';
    this.name = (data.name as string) || '';
    this.provider = (data.provider as string) || '';
    this.modelId = String((data.modelId as string) || '').toLowerCase();
    this.modelProviderName = (data.modelProviderName as string) || '';
    this.connectorId = (data.connectorId as string) || '';

    // not supplied? attempt provider lookup
    if (!this.modelProviderName) {
      this.modelProviderName = ProviderModelNameMap[this.provider] || '';
    }

    this.inputModalities = ((data.inputModalities as string[]) || ['text']).map((value) =>
      String(value).toLowerCase()
    );
    this.outputModalities = ((data.outputModalities as string[]) || ['text']).map((value) =>
      String(value).toLowerCase()
    );
  }

  isMatch(compModel: ProviderModel): boolean {
    const { modelId, provider } = compModel;
    return modelId === this.modelId && provider === this.provider;
  }

  get niceName(): string {
    if (!this.name.includes('/')) {
      return this.name;
    }

    const nameParts = this.name.split('/');
    nameParts.shift();

    return nameParts.join('/') || '';
  }
}
